import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Title = ({ listBottom }) => {
    return (
        <div className="teboil-title">
            <FullWrapper>
                <div className="teboil-titleWrapper">
                    <div className="teboil-titleLeft">
                        <h1 className="teboil-titleLeftHeader">
                            Разработка e&#8209;commerce проекта для&nbsp;бренда Teboil
                        </h1>
                        <div className="teboil-titleLeftMiddle">
                            В&nbsp;этом кейсе расскажем, как наша команда в&nbsp;кратчайшие сроки,
                            всего за&nbsp;4&nbsp;месяца, разработала и&nbsp;выпустила
                            интернет-магазин для бренда Teboil, связав его общим дизайном
                            с&nbsp;основным сайтом бренда и&nbsp;интегрировав с&nbsp;несколькими
                            внешними системами.
                        </div>

                        <div className="teboil-titleLeftBottom">
                            {listBottom.map((item, index) => (
                                <div className="teboil-titleLeftBottomList" key={index}>
                                    <div className="teboil-titleLeftBottomName">{item.name}</div>
                                    <div className="teboil-titleLeftBottomDescription">
                                        {item.description}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="teboil-titleLeftFooter">
                            <div className="teboil-titleLeftFooterTitle">Бренд «Teboil»</div>
                            <a
                                href="https://shop.teboil.ru/"
                                target="_blank"
                                className="teboil-titleLeftFooterLink"
                                rel="noopener noreferrer nofollow"
                            >
                                shop.teboil.ru
                            </a>
                            <div className="teboil-titleLeftFooterSubtitle">
                                Teboil — производитель и поставщик топлива, смазочных материалов и
                                жидкостей для автомобилей.
                            </div>
                        </div>
                    </div>
                    <div className="teboil-titleRight">
                        <img
                            src="/images/pic/teboil/teboil.jpg"
                            alt=""
                            className="teboil-titleRightImage"
                        />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Title;
